module.exports = __webpack_public_path__ + "img/shouye_kuaidi@2x.ca896b75.png";